import { BASEURL, checktoken, headers } from '../../utils/helper'
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { toastError, toastSuccess } from './other.slice';
import Swal from 'sweetalert2';
import axios from 'axios';

const initialState = {
    data: [],
    total: 0,
    pages: 0,
    current: 0,
    error: null,
    loading: false,
}

export const AdminCreatePlanReq = createAsyncThunk('AdminCreatePlanReq', async ({ data, navigate }, { rejectWithValue, dispatch }) => {
    try {
        const response = await axios.post(`${BASEURL}/admin/create/plan`, data,
            { headers: headers() })
            .then((res) => {
                navigate('/admin/subscription-plans');
                dispatch(toastSuccess(res?.data?.message))
                return res.data;
            }).catch((err) => {
                checktoken(err)
                if (err?.response?.data?.error) {
                    dispatch(toastError(err?.response?.data?.error))
                }
                return rejectWithValue(err);
            })
        return response;
    } catch (error) {
        checktoken(error)
        return error;
    }
})

export const AdminUpdatePlanReq = createAsyncThunk('AdminUpdatePlanReq', async ({ data, navigate }, { rejectWithValue, dispatch }) => {
    try {
        const response = await axios.put(`${BASEURL}/admin/plan/update/${data?.id}`, data,
            { headers: headers() })
            .then((res) => {
                navigate('/admin/subscription-plans');
                dispatch(toastSuccess(res?.data?.message))
                return res.data;
            }).catch((err) => {
                checktoken(err)
                if (err?.response?.data?.error) {
                    dispatch(toastError(err?.response?.data?.error))
                }
                return rejectWithValue(err);
            })
        return response;
    } catch (error) {
        checktoken(error)
        return error;
    }
})

export const AdminPlanListReq = createAsyncThunk('AdminPlanListReq', async ({ }, { rejectWithValue, dispatch }) => {
    try {
        const response = await axios.get(`${BASEURL}/admin/plan/list`,
            { headers: headers() })
            .then((res) => {
                return res.data;
            }).catch((err) => {
                checktoken(err)
                if (err?.response?.data?.error) {
                    dispatch(toastError(err?.response?.data?.error))
                }
                return rejectWithValue(err);
            })
        return response;
    } catch (error) {
        checktoken(error)
        return error;
    }
})

export const AdminDeletePlanReq = createAsyncThunk('AdminDeletePlanReq', async ({ id }, { rejectWithValue, dispatch }) => {
    try {
        const response = await axios.delete(`${BASEURL}/admin/plan/delete/${id}`,
            { headers: headers() })
            .then((res) => {
                if (res.data.success) {
                    Swal.fire({
                        title: "Deleted!",
                        text: res?.data?.message,
                        icon: "success"
                    });
                    dispatch(AdminPlanListReq({}))
                }
                return res.data;
            }).catch((err) => {
                checktoken(err)
                if (err?.response?.data?.error) {
                    dispatch(toastError(err?.response?.data?.error))
                }
                return rejectWithValue(err);
            })
        return response;
    } catch (error) {
        checktoken(error)
        return error;
    }
})

export const PlanSlice = createSlice({
    name: 'planSlice',
    initialState: initialState,
    extraReducers: (builder) => {
        builder.addCase(AdminCreatePlanReq.pending, (state, action) => {
            state.loading = true
            return state
        })
        builder.addCase(AdminCreatePlanReq.fulfilled, (state, action) => {
            state.loading = false
            return state
        })
        builder.addCase(AdminCreatePlanReq.rejected, (state, action) => {
            state.loading = false
            state.error = 'Error occured'
        })

        builder.addCase(AdminUpdatePlanReq.pending, (state, action) => {
            state.loading = true
            return state
        })
        builder.addCase(AdminUpdatePlanReq.fulfilled, (state, action) => {
            state.loading = false
            return state
        })
        builder.addCase(AdminUpdatePlanReq.rejected, (state, action) => {
            state.loading = false
            state.error = 'Error occured'
        })


        builder.addCase(AdminPlanListReq.pending, (state, action) => {
            state.loading = true
            state.data = []
            return state
        })
        builder.addCase(AdminPlanListReq.fulfilled, (state, action) => {
            state.loading = false
            state.data = action.payload.data
            return state
        })
        builder.addCase(AdminPlanListReq.rejected, (state, action) => {
            state.loading = false
            state.data = []
            state.error = 'Error occured'
        })
        builder.addCase('LOGOUT', () => initialState)
    }
})

export default PlanSlice.reducer